import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureApiClient } from './client.config';

configureApiClient();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
